import {css} from 'lit';
export const styles = css`:host {
  --background: var(--contrast-light);
  --text-color: var(--dark-text-secondary);
  --text-important-color: var(--dark-text);
  --link-hover-color: var(--link-text-hover);
  --link-active-color: var(--link-active-color);

  display: flex;
  align-items: flex-start;
  color: var(--text-color);
  font-size: var(--font-size-sm);
}

:host([hasParent='true']) {
  margin-left: 48px;
}

aside {
  margin-right: 8px;
}

main {
  flex: 1;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 8px 8px 4px;
  background-color: var(--background);
  border-top-right-radius: var(--border-radius);
}

header a {
    margin-right: 8px;
    color: var(--text-important-color);
    font-weight: 700;
  }

.body {
  padding: 0 8px 8px;
  background-color: var(--background);
  border-bottom-left-radius: var(--border-radius);
  border-bottom-right-radius: var(--border-radius);
}

::slotted(*) {
  margin: 0;
}

footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 8px;
  padding-right: 8px;
}

footer button {
  padding: 0;
  background-color: transparent;
  border: none;
  color: inherit;
  font-weight: 600;
}

footer button:hover {
  color: var(--link-hover-color);
}

footer button:active {
  color: var(--link-active-color);
}

.separator {
  margin-left: 12px;
  margin-right: 12px;
  font-size: var(--font-size-xs);
  line-height: 1;
}

xs-btn-more {
  --link-focus-outline-offset: -2px;

  margin-left: auto;
}
`;
export default styles;
